import { createSlice } from '@reduxjs/toolkit';

const appSlice = createSlice({
  name: 'app',
  initialState: {
    pendingRequestsCount: 0,
  },
  reducers: {
    setPendingRequestsCount: (state, action) => {
      state.pendingRequestsCount = action.payload;
    },
  },
});

export const { setPendingRequestsCount } = appSlice.actions;
export default appSlice.reducer;